import { Instagram } from "lucide-react";
import { COMPANY, INSTAGRAM, NAV_LINKS } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-void pb-24 md:pb-0">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-6">
            <img src="/assets/logo-white.webp" alt="Uusimaa Svets & VVS AB logotyp" className="h-12 w-auto" loading="lazy" />
            <p className="mt-5 font-mono text-xs uppercase tracking-[0.2em] text-neutral-500">Svets • VVS • Rör</p>
            <p className="mt-5 max-w-sm border-l-2 border-weld pl-4 text-sm italic leading-relaxed text-neutral-400">
              ”{COMPANY.motto}”
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">Navigera</p>
            <nav className="mt-5 flex flex-col gap-3" aria-label="Sidfot">
              {NAV_LINKS.map((link) => (
                <button
                  key={link.href}
                  type="button"
                  data-testid={`footer-${link.testid}`}
                  onClick={() => scrollToSection(link.href)}
                  className="w-fit text-left text-sm text-neutral-400 transition-colors duration-200 hover:text-white"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">Kontakt</p>
            <div className="mt-5 space-y-3 text-sm text-neutral-400">
              <p>
                {COMPANY.address1}
                <br />
                {COMPANY.address2}
              </p>
              <p className="font-mono text-[11px] tracking-[0.1em] text-neutral-500">Org.nr {COMPANY.orgNr}</p>
              <a data-testid="footer-phone-link" href={COMPANY.phoneHref} className="block w-fit transition-colors duration-200 hover:text-white">
                {COMPANY.phone}
              </a>
              <a data-testid="footer-email-link" href={COMPANY.emailHref} className="block w-fit break-all transition-colors duration-200 hover:text-white">
                {COMPANY.email}
              </a>
              <a
                data-testid="footer-instagram-link"
                href={INSTAGRAM.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-fit items-center gap-2 transition-colors duration-200 hover:text-white"
              >
                <Instagram className="h-4 w-4 text-weld" />
                {INSTAGRAM.handle}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-neutral-600">
            Copyright © 2026 {COMPANY.name}
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-neutral-600">
            {COMPANY.area} — Haninge — Tungelsta
          </p>
        </div>
      </div>
    </footer>
  );
}
